export class IPlanejamentoPapelTrabalho {
  id: number;
  idPlanejamento: number;
  idPapel: number;
  idTipoAceitavel: number;
  arquivos: IPlanejamentoPapelTrabalhoArquivo[];
  justificativa: string;
  link: string;
  posicao: number;
  nomePapelManual: string;
  
  //Propriedades de Tela
  nomePapel?: string; 
  situacaoNome?: string;   
  controle?: number; //usado para por o name e id no campo input file
  removidos?: IPlanejamentoPapelTrabalhoArquivo[];
  valido?: boolean; //Usado para validar no Envio para Aprovação
  sigla?: string;
  addManual?: boolean; //Usado para controlar se o papel foi add direto na tela
}

export class IPlanejamentoPapelTrabalhoArquivo {
  id: number;
  idPlanejamentoPapel: number;
  nome: string;  
  conteudo: string;
  tipo: string;  

  //Propriedade de tela
  controle: number;
}